<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ph">III.</h2>
<p class="calibre3">When the forces of the Galactic Patrol blasted Helmuth's Grand Base
out of existence and hunted down and destroyed his secondary bases
throughout this galaxy, Boskone's military grasp upon Civilization was
definitely broken. Some minor bases may have escaped destruction, of
course. Indeed, it is practically certain that some of them did so,
for there are comparatively large volumes of our Island Universe which
have not been mapped, even yet, by the planetographers of the Patrol.
It is equally certain, however, that they were relatively few and of no
real importance. For warships, being large, cannot be carried around or
concealed in a vest pocket—a war fleet must of necessity be based upon
a celestial object not smaller than a very large asteroid. Such a base,
lying close enough to any one of Civilization's planets to be of any
use, could not be hidden successfully from the detectors of the Patrol.</p>
<p class="calibre3">Reasoning from analogy, Kinnison quite justifiably concluded that the
back of the drug syndicate had been broken in similar fashion when he
had worked upward through Bominger and Strongheart and Crowninshield
and Jalte to the dread council of Boskone itself. He was, however,
wrong.</p>
<p class="calibre3">For, unlike the battleship, thionite is a vest-pocket commodity.
Unlike the space-fleet base, a drug baron's headquarters can be, and
frequently is, small, compact and highly mobile. Also, the Galaxy is
huge, the number of planets in it immense, the total count of drug
addicts utterly incomprehensible. Therefore it had been found more
efficient to arrange the drug hookup in multiple series-parallel,
instead of in the straight cascade sequence which Kinnison thought that
he had followed up.</p>
<p class="calibre3">He thought so at first, that is, but he did not think so long. He
had thought, and he had told Haynes, as well as Gerrond of Radelix,
that the situation was entirely under control; that with the zwilnik
headquarters blasted out of existence and with all of the regional
heads and many of the planetary chiefs dead or under arrest, all that
the Enforcement men would have to cope with would be the normal bootleg
trickle. In that, too, he was wrong. Gerrond and the other lawmen of
Narcotics had had a brief respite, it is true; but in a few days or
weeks, upon almost as many planets as before, the illicit traffic was
again in full swing.</p>
<p class="calibre3">After the Battle of Tellus, then, it did not take the Gray Lensman long
to discover the above facts. Indeed, they were pressed upon him. He
was, however, more relieved than disappointed at the tidings, for he
knew that he would have material upon which to work. If his original
opinion had been right, if all lines of communication with the now
completely unknown ultimate authorities of the zwilniks had been
destroyed, his task would have been an almost hopeless one.</p>
<p class="calibre3">It would serve no good purpose here to go into details covering his
early efforts, since they embodied, in principle, the same tactics as
those which he had previously employed. He studied, he analyzed, he
investigated. He snooped and he spied. He fought; upon occasion he
killed. And in due course—and not too long a course—he cut into the
sign of what he thought must be a key zwilnik. Not upon Bronseca or
Radelix or Chickladoria, or any other distant planet, but right upon
Tellus!</p>
<p class="calibre3">But he could not locate him. He never saw him upon Tellus. As a matter
of cold fact, he could not find a single person who had ever seen
him or who knew anything definite about him except a number. These
facts, of course, only whetted Kinnison's keenness to come to grips
with the fellow. He might not be a very big shot, but the fact that
he was covering himself up so thoroughly and so successfully made it
abundantly evident that he was a fish well worth landing.</p>
<p class="calibre3">This wight, however, proved to be as elusive as the proverbial flea. He
was never there when Kinnison pounced. In London he was a few minutes
late. In Berlin he was a minute or so too early—and the ape didn't
show up at all. He missed him in Paris and in San Francisco and in
Shanghai. The guy settled down finally in New York, but still the Gray
Lensman could not connect—it was always the wrong street, or the wrong
house, or the wrong time, or something.</p>
<p class="calibre3">Then Kinnison set a snare which should have caught a microbe—and
<i class="calibre9">almost</i> caught his zwilnik. He missed him by one mere second when
he blasted off from New York Spaceport. He was so close that he saw
his flare, so close that he could slap onto the fleeing vessel the beam
of the CRX tracer which he always carried with him.</p>
<p class="calibre3">Unfortunately, however, the Lensman was in mufti at the time, and was
driving a rented flitter. His speedster—altogether too spectacular
and obvious a conveyance to be using in a hush-hush investigation—was
at Prime Base. He didn't want the speedster, anyway, except inside the
<i class="calibre9">Dauntless</i>. He'd go organized this time to chase the lug clear
out of space, if he had to. He shot in a call for the big cruiser, and
while it was coming he made luridly sulphurous inquiry.</p>
<p class="calibre3">Fruitless. His orders had been carried out to the letter, except in
the one detail of not allowing any vessel to take off. This take-off
absolutely could not be helped—it was just one of those things. The
ship was a Patrol speedster from Deneb V, registry number so-and-so.
Said he was coming in for servicing. Came in on the north beam,
identified himself properly—Lieutenant Quirkenfal, of Deneb V, he said
he was, and it checked—</p>
<p class="calibre3">It would check, of course. The zwilnik that Kinnison had been chasing
so long certainly would not be guilty of any such raw, crude work as a
faulty identification. In fact, right then he probably looked just as
much like Quirkenfal as the lieutenant himself did.</p>
<p class="calibre3">"He wasn't in any hurry at all," the informant went on. "He waited
around for his landing clearance, then slanted in on his assigned slide
to the service pits. In the last hundred yards, though, he shot off to
one side and sat down, <i class="calibre9">plop</i>, broadside on, clear over there in
the far corner of the field. But he wasn't down but a second, sir.
Long before anybody could get to him—before the cruisers could put a
beam on him, even—he blasted off as though the devil were on his tail.
Then you came along, sir, but we did put a CRX tracer on him—"</p>
<p class="calibre3">"I did that much, myself," Kinnison stated, morosely. "He stopped
just long enough to pick up a passenger—my zwilnik, of course—then
flitted—and you fellows let him get away with it."</p>
<p class="calibre3">"But we couldn't help it, sir," the official protested. "And, anyway,
he couldn't possibly have—"</p>
<p class="calibre3">"He sure could. You'd be surprised no end at what that ape can do."</p>
<p class="calibre3">Then the <i class="calibre9">Dauntless</i> flashed in; not asking but demanding instant
right of way.</p>
<p class="calibre3">"Look around, fellows, if you like, but you won't find a damned thing,"
Kinnison's uncheering conclusion came back as he sprinted toward the
dock into which his battleship had settled. "The lug hasn't left a
loose end dangling yet."</p>
<p class="calibre3">By the time the great Patrol ship had cleared the stratosphere,
Kinnison's CRX, powerful and tenacious as it was, was just barely
registering a line. But that was enough. Henry Henderson, master pilot,
stuck the <i class="calibre9">Dauntless'</i> needle nose into that line and shoved into
the driving projectors every watt of "oof" that those Brobdingnagian
creations would take.</p>
<p class="calibre3">They had been following the zwilnik for three days now, Kinnison
reflected, and his CRX's were none too strong yet. They were
overhauling him mighty slowly; and the <i class="calibre9">Dauntless</i> was supposed
to be the fastest thing in space. That can up ahead had plenty of
legs—must have been souped up to the limit. This was apt to be a long
chase, but he'd get that bozo if he had to chase him on a geodesic line
along the hyper-dimensional curvature of space clear back to Tellus
where he started from!</p>
<p class="calibre3">They did not have to circumnavigate total space, of course, but they
did almost leave the Galaxy before they could get the fugitive upon
their plates. The stars were thinning out fast; but still, hazily
before them in a vastness of distance, there stretched a milky band of
opalescence.</p>
<p class="calibre3">"What's coming up, Hen—a rift?" Kinnison asked.</p>
<p class="calibre3">"Uh-huh, Rift 94," the pilot replied. "And if I remember right, that
arm up ahead is Dunstan's Region and it has never been explored. I'll
have the chart room check up on it."</p>
<p class="calibre3">"Never mind! I'll go check it myself—I'm curious about this whole
thing."</p>
<p class="calibre3">Unlike any smaller vessel, the <i class="calibre9">Dauntless</i> was large enough so
that she could—and hence as a matter of course did—carry every
space chart issued by all the various Boards and Offices and Bureaus
concerned with space, astronomy, astrogation and planetography. She had
to, for there were usually minds aboard which were apt at any time to
become intensely and unpredictably interested in anything, anywhere.
Hence it did not take Kinnison long to obtain what little information
there was.</p>
<p class="calibre3">The vacancy they were approaching was Rift 94, a vast space,
practically empty of stars, lying between the main body of the
Galaxy and a minor branch of one of its prodigious spiral arms. The
opalescence ahead was the branch—Dunstan's Region. Henderson was
right; it had never been explored.</p>
<p class="calibre3">The Galactic Survey, which has not even yet mapped the whole of the
Galaxy proper, had of course done no systematic work upon such outlying
sections as the spiral arms. Some such regions were well known and well
mapped, it is true; either because its own population, independently
developing means of space flight, had come into contact with our
Civilization upon its own initiative or because private exploration and
investigation had opened up profitable lines of commerce. But Dunstan's
Region was bare. No people resident in it had ever made themselves
known; no private prospecting, if there had ever been any such, had
revealed anything worthy of exploitation or development. And, with so
many perfectly good uninhabited planets so much nearer to Galactic
Center, it was, of course, much too far out for colonization.</p>
<p class="calibre3">Through the rift, then, and into Dunstan's Region the <i class="calibre9">Dauntless</i>
bored at the unimaginable pace of her terrific full-blast drive. The
tracers' beams grew harder and more taut with every passing hour;
the fleeing speedster itself grew large and clear upon the plates.
The opalescence of the spiral arm became a firmament of stars. A sun
detached itself from that firmament; a dwarf of Type G—and planets.</p>
<p class="calibre3">One of these in particular, the second out, looked so much like Earth
that it made some of the observers homesick. There were the familiar
polar ice caps, the atmosphere and stratosphere, the high-piled,
billowy masses of clouds. There were vast blue oceans, there were huge,
unfamiliar continents glowing with chlorophyllic green.</p>
<p class="calibre3">At the spectroscopes, at the bolometers, at the many other instruments
men went rapidly and skillfully to work.</p>
<p class="calibre3">"Hope the ape's heading for Two, and I think he is," Kinnison remarked,
as he studied the results. "People living on that planet would be human
to ten places, for all the tea in China. No wonder he was so much at
home on Tellus—Yup, it's Two—there, he's gone inert."</p>
<p class="calibre3">"Whoever is piloting that can went to school just one day in his life
and that day it rained and the teacher didn't come," Henderson snorted.
"And he's trying to balance her down on her tail—look at her bounce
and flop around! He's just begging for a crack-up."</p>
<p class="calibre3">"If he makes it, it'll be bad—plenty bad," Kinnison mused. "He'll
gain a lot of time on us while we're rounding the globe on our landing
spiral."</p>
<p class="calibre3">"Why spiral, Kim? Why not follow him down, huh? Our intrinsic is no
worse than his—it's the same one, in fact."</p>
<p class="calibre3">"Get conscious, Hen. You haven't got a speedster under you now."</p>
<p class="calibre3">"So what? I can certainly handle this scrap heap a damn sight better
than that ground-gripper is handling that speedster." Henry Henderson,
Master Pilot No. 1 of the Service, was not bragging. He was merely
voicing what to him was the simple and obvious truth.</p>
<p class="calibre3">"Mass is what. Mass and volume and velocity and inertia and power. You
never stunted this much weight before, did you?"</p>
<p class="calibre3">"No; but what of it? I took a course in piloting once, in my youth." He
was then a grand old man of twenty-eight or thereabouts. "I can line up
the main rear center pipe onto any grain of sand you want to pick out
on that field, and hold her there until she slags it down."</p>
<p class="calibre3">"If you think you can spell 'able,' hop to it!"</p>
<p class="calibre3">"QX, this is going to be fun." Henderson gleefully accepted the
challenge, then clicked on his general alarm microphone. "Strap down,
everybody, for inert maneuvering. Class 9. Four G's on the tail. Tail
over to belly landing. Hipe!"</p>
<p class="calibre3">The Bergenholms were cut and as the tremendously massive
superdreadnought, inert, shot off at an angle under its Tellurian
intrinsic velocity, Master Pilot No. 1 proved his rating. As much a
virtuoso of the banks and tiers of blast keys and levers before him as
a concert organist is of his instrument, his hands and feet flashed
hither and yon. Not music?—the bellowing, crescendo thunders of those
jets <i class="calibre9">were</i> music to the hard-boiled spacehounds who heard them.
And in response to the exact placement and the precisely measured power
of those blasts the great sky rover spun, twisted and bucked as her
prodigious mass was forced into motionlessness relative to the terrain
beneath her.</p>
<p class="calibre3">Four G's, Kinnison reflected, while this was going on. Not bad—he had
thought that it would take five; possibly six. He could sit up and take
notice at four, and he did so.</p>
<p class="calibre3">This world wasn't very densely populated, apparently. Quite a few
cities, but all just about on the equator. Nothing in the temperate
zones at all; even the highest power revealed no handiwork of man.
Virgin forest, untouched prairie. Lots of roads and things in the
torrid zone, but nothing anywhere else. The speedster was making a
rough and unskillful, but not catastrophic landing.</p>
<p class="calibre3">The field which was their destination lay just outside a large city.
Funny—it wasn't a space-field at all. No docks, no pits, no ships.
Low, flat buildings—hangars. An air-field, then, although not like any
air-field upon Tellus. Too small. Gyros? 'Copters? Didn't see any—all
little ships. Crates—biplanes and tripes. Made of wire and fabric.
Wotta woil, wotta woil!</p>
<p class="calibre3">The <i class="calibre9">Dauntless</i> landed, fairly close to the now deserted speedster.</p>
<p class="calibre3">"Hold everything, men," Kinnison cautioned. "Something funny here. I'll
do a bit of looking around before we open up."</p>
<p class="calibre3">He was not surprised that the people in and around the airport were
human to at least ten places of classification; he had expected
that from the planetary data. Nor was he surprised at the fact that
they wore no clothing. He had learned long since that, while human
or near-human races—particularly the women—wore at least a few
ornaments, the wearing of clothing as such, except when it was actually
needed for protection, was far more the exception than the rule. And,
just as a Martian, out of deference to conventions, wears a light robe
upon Tellus, Kinnison as a matter of course stripped to his evenly
tanned hide when visiting planets upon which nakedness was <i class="calibre9">de
rigueur</i>. He had attended more than one State function, without a
quibble or a qualm, tastefully attired in a pair of sandals and his
DeLameters.</p>
<p class="calibre3">No, the startling fact was that there was not a man in sight anywhere
around the place; there was nothing male perceptible as far as his
sense of perception could reach. Women were laboring, women were
supervising, women were running the machines. Women were operating the
airplanes and servicing them. Women were in the offices. Women and
girls and little girls and girl babies filled the waiting rooms and the
automobilelike conveyances parked near the airport and running along
the streets.</p>
<p class="calibre3">And, even before Kinnison had finished uttering his warning, while his
hand was in the air reaching for a spy-ray switch, he felt an alien
force attempting to insinuate itself into his mind.</p>
<p class="calibre3">Fat chance! With any ordinary mind it would have succeeded, but in
the case of the Gray Lensman it was just like trying to stick a pin
unobtrusively into a panther. He put up a solid block automatically,
instantaneously; then, a fraction of a second later, a thought-tight
screen enveloped the whole vessel.</p>
<p class="calibre3">"Did any of you fellows—" he began, then broke off. They wouldn't have
felt it, of course; their brains could have been read completely with
them none the wiser. He was the only Lensman aboard, and even most
Lensmen couldn't—this was <i class="calibre9">his</i> oyster. But that kind of stuff,
on such an apparently backward planet as this? It didn't make sense,
unless that zwilnik—Ah, this <i class="calibre9">was</i> his oyster, absolutely!</p>
<p class="calibre3">"Something funnier even than I thought—thought-waves," he calmly
continued his original remark. "Thought I'd better undress to go out
there, but I'm not going to. I'd wear full armor, except that I may
need my hands or have to move fast. If they get insulted at my clothes,
I'll apologize later."</p>
<p class="calibre3">"But, listen, Kim, you can't go out there alone—especially without
armor!"</p>
<p class="calibre3">"Sure I can. I'm not taking any chances. You fellows couldn't do me
much good out there, but you can here. Break out the 'copter and keep a
spy-ray on me. If I give you the signal, go to work with a couple of
narrow needle beams. Pretty sure that I won't need any help, but you
can't always tell."</p>
<p class="calibre3">The air lock opened and Kinnison stepped out. He had a high-powered
thought-screen, but he did not need it—yet. He had his DeLameters. He
had also a weapon deadlier by far even than those mighty portables;
a weapon so utterly deadly that he had not used it. He did not need
to test it—since Worsel had said that it would work, it would. The
trouble with it was that it could not merely disable; if used at all it
killed, with complete and grim finality. And behind him he had the full
awful power of the <i class="calibre9">Dauntless</i>. He had nothing to worry about.</p>
<p class="calibre3">Only when the spaceship had settled down upon and into the hard-packed
soil of the airport could those at work there realize just how big
and how heavy the visitor was. Practically everyone stopped work and
stared, and they continued to stare as Kinnison strode toward the
office. The Lensman had landed upon many strange planets, he had been
met in divers fashions and with various emotions; but never before
had his presence stirred up anything even remotely resembling the
sentiments written so plainly upon these women's faces and expressed
even more plainly in their seething thoughts.</p>
<p class="calibre3">Loathing, hatred, detestation—not precisely any one of the three,
yet containing something of each. As though he were a monstrosity, a
revolting abnormality that should be destroyed on sight. Beings such
as the fantastically ugly, spiderlike denizens of Dekanore VI had
shuddered at the sight of him, but their thoughts were mild compared to
these. Besides, that was natural enough. Any human being would appear
a monstrosity to such as those. But these women were human; as human as
he was. He didn't get it, at all.</p>
<p class="calibre3">Kinnison opened the door and faced the manager, who was standing at
that other-worldly equivalent of a desk. His first glance at her
brought to the surface of his mind one of the peculiarities which he
had already unconsciously observed. Here, for the first time in his
life, he saw a woman without any touch whatever of personal adornment.
She was tall and beautifully proportioned, strong and fine; her smooth
skin was tanned to a rich and even brown. She was clean, almost
blatantly so.</p>
<p class="calibre3">But she wore no jewelry, no bracelets, no ribbons; no decorations
of any sort or kind. No paint, no powder, no touch of perfume. Her
heavy, bushy eyebrows had never been either plucked or clipped. Some
of her teeth had been expertly filled, and she had a two-tooth bridge
that would have done credit to any Tellurian dentist—but her hair!
It, too, was painfully clean, as was the white scalp beneath it,
but aesthetically it was a mess. Some of it reached almost to her
shoulders, but it was very evident that whenever a lock grew long
enough to be a bother she was wont to grab it and hew it off, as
close to the skull as possible, with whatever knife, shears or other
implement came readiest to hand.</p>
<p class="calibre3">These thoughts and the general inspection did not take any appreciable
length of time, of course. Before Kinnison had taken two steps toward
the manager's desk, he directed a thought:</p>
<p class="calibre3">"Kinnison of Sol III—Lensman, Unattached. It is possible, however,
that neither Tellus nor the Lens are known upon this planet?"</p>
<p class="calibre3">"Neither is known, nor do we care to know them," she replied, coldly.
Her brain was keen and clear; her personality vigorous, striking,
forceful. But, compared with Kinnison's doubly Arisian-trained mind,
hers was woefully slow. He watched her assemble the mental bolt which
was intended to slay him then and there. He let her send it, then
struck back. Not lethally, not even paralyzingly, but solidly enough so
that she slumped down, almost unconscious, into a nearby chair.</p>
<p class="calibre3">"It's good technique to size a man up before you tackle him, sister,"
he advised her when she had recovered. "Couldn't you tell from the feel
of my mind-block that <i class="calibre9">you</i> couldn't crack it?"</p>
<p class="calibre3">"I was afraid so," she admitted, hopelessly, "but I had to kill you if
I possibly could. Since you are the stronger you will, of course, kill
me." Whatever else these peculiar women were, they were stark realists.
"Go ahead—get it over with. But it <i class="calibre9">can't</i> be!" Her thought was a
wail of protest. "I do not grasp your thought of 'a man,' but you are
certainly a male; and no mere <i class="calibre9">male</i> can be—can <i class="calibre9">possibly</i>
be, ever—as strong as a person."</p>
<p class="calibre3">Kinnison got that thought perfectly, and it rocked him. She did not
think of herself as a woman, a female, at all. She was simply a
<i class="calibre9">person</i>. She could not understand even dimly Kinnison's reference
to himself as a man. To her, "man" and "male" were synonymous terms.
Both meant sex, and nothing whatever except sex.</p>
<p class="calibre3">"I have no intention of killing you, or anyone else upon this planet,"
he informed her levelly, "unless I absolutely have to. But I have
chased that speedster over there all the way from Tellus, and I intend
to get the man that drove it here, if I have to wipe out half of your
population to do it. Is that perfectly clear?"</p>
<p class="calibre3">"That is perfectly clear, male." Her mind was fuzzy with a melange
of immiscible emotions. Surprise and relief that she was not to be
slain out of hand; disgust and repugnance at the very idea of such
a horrible, monstrous male creature having the audacity to exist;
stunned, disbelieving wonder at his unprecedented power of mind; a
dawning comprehension that there were perhaps some things which she did
not know: these and numerous other conflicting thoughts surged through
her mind. "But there was no male within the space-traversing vessel
which you think of as a 'speedster,'" she concluded, surprisingly.</p>
<p class="calibre3">And he knew that she was not lying. No mentality in existence, not even
that of Mentor the Arisian, could lie to Gray Lensman Kinnison against
his will.</p>
<p class="calibre3">"Damnation!" he snorted to himself. "Fighting against <i class="calibre9">women</i>
again!"</p>
<p class="calibre3">"Who was she, then—it, I mean?" he hastily corrected the thought.</p>
<p class="calibre3">"It was our elder sister—"</p>
<p class="calibre3">The thought so translated by the man was not really "sister." That
term, having distinctly sexual connotations and implications, would
never have entered the mind of any "person" of Lyrane II. "Elder child
of the same heritage" was more like it.</p>
<p class="calibre3">"—and another person from what it claimed was another world," the
thought flowed smoothly on. "An entity, rather, not really a person,
but you would not be interested in that, of course."</p>
<p class="calibre3">"Of course I would," Kinnison assured her. "In fact, it is this other
person, and not your elderly relative, in whom I am interested. But you
say that it is an entity, not a person. How come? Tell me all about it."</p>
<p class="calibre3">"Well, it looked like a person, but it wasn't. Its intelligence was
low, its brain power was small. And its mind was upon things ... its
thoughts were so—"</p>
<p class="calibre3">Kinnison grinned at the Lyranian's efforts to express clearly thoughts
so utterly foreign to her mind as to be totally incomprehensible.</p>
<p class="calibre3">"You don't know what that entity was, but I do," he broke in upon her
floundering. "It was a person who was also, and quite definitely, a
female. Right?"</p>
<p class="calibre3">"But a person couldn't—couldn't <i class="calibre9">possibly</i>—be a female!" she
protested. "Why, even biologically, it doesn't make sense. There are no
such things as females—there <i class="calibre9">can't</i> be!" And Kinnison saw her
viewpoint clearly enough. According to her sociology and conditioning
there could not be.</p>
<p class="calibre3">"We'll go into that later," he told her. "What I want now is this
female zwilnik. Is she—or it—with your elder relative now?"</p>
<p class="calibre3">"Yes. They will be having dinner in the hall very shortly."</p>
<p class="calibre3">"Sorry to be a bother, but you'll have to take me to them—right now."</p>
<p class="calibre3">"Oh, may I? Since I could not kill you myself, I must take you to them
so that they can do it. I have been wondering how I could force you to
go there," she explained, naïvely.</p>
<p class="calibre3">"Henderson?" The Lensman spoke into his microphone—thought-screens, of
course, being no barrier to radio waves. "I'm going after the zwilnik.
This woman here is taking me. Have the 'copter stay over me, ready to
needle anything I tell them to. While I'm gone go over that speedster
with a fine-tooth comb, and when you get everything we want, blast it.
It and the <i class="calibre9">Dauntless</i> are the only space cans on the planet, and
I haven't got a picture of them taking the cruiser away from you. But
keep your thought-screens up. Don't let them down for a fraction of a
second, because these janes here carry plenty of jets and they're just
as sweet and reasonable as a cageful of cateagles. Got it?"</p>
<p class="calibre3">"On the tape, chief," came instant answer. "But don't take any chances,
Kim. Sure you can swing it alone?"</p>
<p class="calibre3">"Jets enough and to spare," Kinnison assured him, curtly. Then, as the
Tellurians' helicopter shot into the air, he again turned his thought
to the manager.</p>
<p class="calibre3">"Let's go," he directed, and she led him across the way to a row of
parked ground cars. She manipulated a couple of levers and smoothly, if
slowly, the little vehicle rolled away.</p>
<p class="calibre3">The distance was long and the pace was slow. The woman was driving
automatically, the while her every sense was concentrated upon finding
some weak point, some chink in his barrier, through which to thrust at
him. Kinnison was amazed—stumped—at her fixity of purpose; at her
grimly single-minded determination to make an end of him. She was out
to get him, and she was not fooling.</p>
<p class="calibre3">"Listen, sister," he thought at her, after a few minutes of it; almost
plaintively, for him. "Let's be reasonable about this thing. I told
you that I didn't want to kill you; why in all the iridescent hells of
space are you so dead set on killing me? If you don't behave yourself,
I'll give you a treatment that will make your head ache for the next
six months. Why don't you snap out of it, you dumb little lug, and be
friends?"</p>
<p class="calibre3">This thought jarred her so that she stopped the car, the better to
stare directly and viciously into his eyes.</p>
<p class="calibre3">"Be <i class="calibre9">friends</i>? With a <i class="calibre9">male</i>?" The thought literally seared
its way into the man's brain.</p>
<p class="calibre3">"Listen, half-wit!" Kinnison stormed, exasperated. "Forget your
narrow-minded, one-planet prejudices and think for a minute, if you
can think—use that pint of bean soup inside your skull for something
besides hating me all over the place. Get this—I am no more a male
than you are the kind of a female that you think, by analogy, such a
creature would have to be if she could exist in a sane and logical
world."</p>
<p class="calibre3">"Oh." The Lyranian was taken aback at such cavalier instruction. "But
the others, those in your so-immense vessel, they are of a certainty
males," she stated with conviction. "I understood what you told them
via your telephone-without-conductors. You have mechanical shields
against the thought which kills. Yet you do not have to use it, while
the others—males indubitably—do. You yourself are not entirely a
male; your brain is almost as good as a person's."</p>
<p class="calibre3">"Better, you mean," he corrected her. "You're wrong. All of us of
the ship are men—all alike. But a man on a job can't concentrate
all the time on defending his brain against attack, hence the use of
thought-screens. I can't use a screen out here, because I've got to
talk to you people. See?"</p>
<p class="calibre3">"You fear us, then, so little?" she flared, all of her old animosity
blazing out anew. "You consider our power, then, so small a thing?"</p>
<p class="calibre3">"Right. Right to a hair," he declared, with tightening jaw. But he did
not believe it—quite. This girl was just about as safe to play around
with as five-feet-eleven of coiled bushmaster, and twice as deadly.</p>
<p class="calibre3">She could not kill him mentally. Nor could the elder sister—whoever
she might be—and her crew; he was pretty sure of that. But if they
couldn't do him in by dint of brain it was a foregone conclusion that
they would try brawn. And brawn they certainly had. This jade beside
him weighed a hundred sixty-five or seventy, and she was trained down
fine. Hard, limber and fast. He might be able to lick three or four of
them—maybe half a dozen—in a rough-and-tumble brawl; but more than
that would mean either killing or being killed. Damn it all! He'd never
killed a woman yet, but it looked as though he might have to start in
pretty quick now.</p>
<p class="calibre3">"Well, let's get going again," he suggested, "and while we're en route
let's see if we can't work out some basis of co-operation—a sort of
live-and-let-live arrangement. Since you understood the orders I gave
the crew, you realize that our ship carries weapons capable of razing
this entire city in a space of minutes." It was a statement, not a
question.</p>
<p class="calibre3">"I realize that." The thought was muffled in helpless fury. "Weapons,
weapons—always <i class="calibre9">weapons</i>! The eternal <i class="calibre9">male</i>! If it were
not for your huge vessel and the peculiar airplane hovering over us, I
would claw your eyes out and strangle you with my bare hands!"</p>
<p class="calibre3">"That would be a good trick if you could do it," he countered, equably
enough. "But listen, you frustrated young murderess. You have already
shown yourself to be, basically, a realist in facing physical facts.
Why not face mental, intellectual facts in the same spirit?"</p>
<p class="calibre3">"Why, I do, of course. I <i class="calibre9">always</i> do!"</p>
<p class="calibre3">"You do not," he contradicted, sharply. "Males, according to your
lights, have two—and only two—attributes. One, they breed. Two, they
fight. They fight each other, and everything else, to the death and at
the drop of a hat. Right?"</p>
<p class="calibre3">"Right, but—"</p>
<p class="calibre3">"But nothing—let me talk. Why didn't you breed the combativeness out
of your males, hundreds of generations ago?"</p>
<p class="calibre3">"They tried it once, but the race began to deteriorate," she admitted.</p>
<p class="calibre3">"Exactly. Your whole set-up is cockeyed—unbalanced. You can think of
me only as a male—one to be destroyed on sight, since I am not like
one of yours. Yet, when I could kill you and had every reason to do so,
I didn't. We can destroy you all, but we won't unless we must. What's
the answer?"</p>
<p class="calibre3">"I don't know," she confessed, frankly. Her frenzied desire for killing
abated, although her ingrained antipathy and revulsion did not. "In
some ways, you do seem to have some of the instincts and qualities of
a ... almost of a person."</p>
<p class="calibre3">"I am a person—"</p>
<p class="calibre3">"You are <i class="calibre9">not</i>! Do you think that I am to be misled by the silly
coverings you wear?"</p>
<p class="calibre3">"Just a minute. I am a person of a race having two <i class="calibre9">equal</i>
sexes. Equal in every way. Numbers, too—one man and one woman—" and
he went on to explain to her, as well as he could, the sociology of
Civilization.</p>
<p class="calibre3">"Incredible!" she gasped the thought.</p>
<p class="calibre3">"But true," he assured her. "And now are you going to lay off me and
behave yourself, like a good little girl, or am I going to have to do
a bit of massaging on your brain? Or wind that beautiful body of yours
a couple of times around a tree? I'm asking this for your own good,
kid, believe me."</p>
<p class="calibre3">"Yes, I do believe you," she marveled. "I am becoming convinced
that ... that perhaps you <i class="calibre9">are</i> a person—at least of a
sort—after all."</p>
<p class="calibre3">"Sure I am—that's what I've been trying to tell you for an hour. And
cancel that 'of a sort,' too—"</p>
<p class="calibre3">"But tell me," she interrupted, "a thought you used—'beautiful.' I do
not understand it. What does it mean, 'beautiful body'?"</p>
<p class="calibre3">"Holy Klono's whiskers!" If Kinnison had never been stumped before,
he was now. How could he explain beauty, or music, or art, to
this ... this matriarchal savage? How explain cerise to a man born
blind? And, above all, who had ever heard of having to explain to a
woman—to any woman, anywhere in the whole macrocosmic universe—that
she in particular was beautiful?</p>
<p class="calibre3">But he tried. In her mind he spread a portrait of her as he had seen
her first. He pointed out to her the graceful curves and lovely
contours, the lithely flowing lines, the perfection of proportion and
modeling and symmetry, the flawlessly smooth, firm-textured skin, the
supple, hard-trained fineness of her whole physique. No soap. She
tried, in brow-furrowing concentration, to get it, but in vain. It
simply did not register.</p>
<p class="calibre3">"But that is merely efficiency, everything you have shown," she
declared. "Nothing else. I must be so, for my own good and for the good
of those to come. But I think that I have seen some of your beauty,"
and in turn she sent into his mind a weirdly distorted picture of a
human woman. The zwilnik he was following, Kinnison decided instantly.</p>
<p class="calibre3">She would be jeweled, of course, but not that heavily—a horse couldn't
carry that load. And no woman ever born put paint on that thick, or
reeked so of violent perfume, or plucked her eyebrows to such a thread,
or indulged in such a hairdo.</p>
<p class="calibre3">"If <i class="calibre9">that</i> is beauty, I want none of it," the Lyranian declared.</p>
<p class="calibre3">Kinnison tried again. He showed her a waterfall, this time, in a
stupendous gorge, with appropriate cloud formations and scenery.
That, the girl declared, was simply erosion. Geological formations
and meteorological phenomena. Beauty still did not appear. Painting,
it appeared to her, was a waste of pigment and oil. Useless and
inefficient—for any purpose of record the camera was much more precise
and truthful. Music—vibrations in the atmosphere—would of necessity
be simply a noise; and noise—any kind of noise—was not efficient.</p>
<p class="calibre3">"You poor little devil." The Lensman gave up. "You poor, ignorant,
soul-starved little devil. And the worst of it is that you don't even
realize—and never can realize—what you are missing."</p>
<p class="calibre3">"Don't be silly." For the first time, the woman actually laughed. "You
are utterly foolish to make such a fuss about such trivial things."</p>
<p class="calibre3">Kinnison quit, appalled. He knew, now, that he and this apparently
human creature beside him were as far apart as the Galactic Poles in
every essential phase of life. He had heard of matriarchies, but he
had never considered what a real matriarchy, carried to its logical
conclusion, would be like.</p>
<p class="calibre3">This was it. For ages there had been, to all intents and purposes,
only one sex; the masculine element never having been allowed to rise
above the fundamental necessity of reproducing the completely dominant
female. And that dominant female had become, in every respect save the
purely and necessitously physical one, absolutely and utterly sexless.
Men, upon Lyrane II, were dwarfs about thirty inches tall. They had
the temper and the disposition of a mad Radeligian cateagle, the
intellectual capacity of a Zabriskan fontema. They were not regarded as
people, either at birth or at any subsequent time. To maintain a static
population, each person gave birth to one person, on the grand average.
The occasional male baby—about one in a hundred—did not count. He was
not even kept at home, but was taken immediately to the "maletorium,"
in which he lived until attaining maturity.</p>
<p class="calibre3">One man to a hundred or so women for a year, then death. The hundred
persons had their babies at twenty-one or twenty-two years of age—they
lived to an average age of a hundred years—then calmly blasted their
male's mind and disposed of his carcass. The male was not exactly
an outcast; not precisely a pariah. He was tolerated as a necessary
adjunct to the society of persons, but in no sense whatever was he a
member of it.</p>
<p class="calibre3">The more Kinnison pondered this hookup the more appalled he became.
Physically, these people were practically indistinguishable from
human, Tellurian, Caucasian women. But mentally, intellectually, in
every other way, how utterly different! Shockingly, astoundingly so
to any really human being, whose entire outlook and existence is
fundamentally, however unconsciously or subconsciously, based upon and
conditioned by the prime division of life into two fully co-operant
sexes. It didn't seem, at first glance, that such a cause could have
such terrific effects; but here they were. In cold reality, these women
were no more human than were the ... the Eich. Take the Posenians,
or the Rigellians, or even the Velantians. Any normal, stay-at-home
Tellurian woman would pass out cold if she happened to stumble onto
Worsel in a dark alley at night. Yet the members of his repulsively
reptilian-appearing race, merely because of having a heredity of
equality and co-operation between the sexes, were in essence more
nearly human than were these tall, splendidly built, actually and
intrinsically beautiful creatures of Lyrane II!</p>
<p class="calibre3">"This is the hall," the person informed him, as the car came to a halt
in front of a large structure of plain gray stone. "Come with me."</p>
<p class="calibre3">"Gladly," and they walked across the peculiarly bare grounds. They
were side by side, but a couple of feet apart. She had been altogether
too close to him in the little car. She did not want this male—or
<i class="calibre9">any</i> male—to touch her or to be near her. And, considerably to
her surprise, if the truth were to be known, the feeling was entirely
mutual. Kinnison would have preferred to touch a Borovan slime-lizard.</p>
<p class="calibre3">They mounted the granite steps. They passed through the dull,
weather-beaten portal. They were still side by side—but they were now
a full yard apart.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?3c3ab9e8